

import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { ListarDoctorClinica } from '../../../Service/Service.doctor'
import { ControllerCrearSeguro } from '../../../Service/Services.seguros'
import { GetTokenDecoded } from '../../../utils/storeUsuario'
import Alert from '../../Alert/Alert'
import SelectSearchble from '../../SelectSeachble/SelectSearchble'
import { ListarTiposSeguros } from '../../../Service/Service.tipoSerguro'

export default function CreateSeguro({setPing, ping, show, handleClose, editSeguro}) {

    const refDiv = useRef(null)
    const [doctores, setDoctores] = useState([])
    const [send, setSend] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [msj, setMsj] = useState('')
    const [fecha_corte, setFechaCorte] = useState(false)
    const [fecha_corte_seguro, setFechaCorteSeguro] = useState(moment().format('YYYY-MM-DD'))

    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedTSeguroOption, setSelectedTSeguroOption] = useState(null);
    const [seguro, setSeguro] = useState({
      idclinica: 0,
      idtiposeguro: 0,
      nombre: '',
      ruc: '',
      razon_social: '',
      direccion: '',
      responsable: '',
      telefono: '',
      correo_electronico: '',
      estado: '',
      medico_auditor: '',
      fecha_corte: false,

    })
  
    const {register, setValue, handleSubmit, formState:{errors}} = useForm();

    const [tipoSeguro, setTipoSeguro] = useState([])
  
    const handleChange = selectedOption => {
      setSelectedOption(selectedOption);
    };

    const handleChangeTipoSeguro = selectedTSeguroOption => {
        setSelectedTSeguroOption(selectedTSeguroOption);
      };

    useEffect(() => {
        (async()=>{
            const doct = await ListarDoctorClinica(GetTokenDecoded().idclinica);
            const tipoSeguro = await ListarTiposSeguros(GetTokenDecoded().idclinica)

            if (doct.data.length > 0) {
                
                const doctoresFormatted = doct.data.map((doc) => ({
                    value: doc.iddoctor,
                    label: doc.nombre
                }));

                setDoctores(doctoresFormatted);
            }

            if ( tipoSeguro.data.length > 0 ) {
                const tipoSeguroFormatteed = tipoSeguro.data.map((tseg) => ({
                    value: tseg.idtiposeguro,
                    label: tseg.tipo
                }));

                setTipoSeguro(tipoSeguroFormatteed)
            }
        })()
    }, [])
  
    useEffect(() => {
      if(editSeguro){
        setSeguro(editSeguro)
        setValue('nombre', editSeguro.nombre)
        setValue('ruc', editSeguro.ruc)
        setValue('razon_social', editSeguro.razon_social)
        setValue('direccion', editSeguro.direccion)
        setValue('responsable', editSeguro.responsable)
        setValue('telefono', editSeguro.telefono)
        setValue('correo_electronico', editSeguro.correo_electronico)
        setValue('estado', editSeguro.estado)
        setValue('medico_auditor', editSeguro.medico_auditor)
        setValue('fecha_corte', editSeguro.fecha_corte)
        setValue('fecha_corte_seguro', editSeguro.fecha_corte_seguro)
        setFechaCorte(editSeguro.fecha_corte)
        setFechaCorteSeguro(editSeguro.fecha_corte_seguro);
        
        const selectedDoctor = doctores.find(doc => doc.value === editSeguro.medico_auditor);
        setSelectedOption(selectedDoctor || null);

        const selectedTipoSeguro = tipoSeguro.find(tipo => tipo.value === editSeguro.tipo_seguro_id);
        setSelectedTSeguroOption(selectedTipoSeguro || null);
      }else{
        setSeguro({
            idclinica: 0,
            idtiposeguro: 0,
            nombre: '',
            ruc: '',
            razon_social: '',
            direccion: '',
            responsable: '',
            telefono: '',
            correo_electronico: '',
            estado: '',
            medico_auditor: '',
            fecha_corte: false,
          });
          setValue('fecha_corte', false);
          setValue('fecha_corte_seguro', moment().format('YYYY-MM-DD'));
          setSelectedOption(null);
          setSelectedTSeguroOption(null);
      }
    }, [show,doctores, tipoSeguro, editSeguro])
  
  
  
    const onSubmit = handleSubmit(async(data) => {
      if(JSON.stringify(data) === JSON.stringify(editSeguro)){
        setMsj('No hay cambios para guardar')
        refDiv.current.scrollIntoView({behavior: 'smooth'})
        setTimeout(() => {
          setAlertType('')
        }, 3000);
        return
      }
      setSend(true)

      if(selectedOption){
        data['medico_auditor'] = selectedOption.value;
      }

      if (selectedTSeguroOption) {
        data['idtiposeguro'] = selectedTSeguroOption.value;
      }
      if(editSeguro){
        data['idseguro'] = editSeguro.idseguro
        data['idclinica'] = editSeguro.idclinica
      }else{
        data['idseguro'] = 0
        data['idclinica'] = GetTokenDecoded().idclinica
      }

      //validar fecha corte
      if(fecha_corte){
        data['fecha_corte'] = true
        data['fecha_corte_seguro'] = fecha_corte_seguro
      }

      const response = await ControllerCrearSeguro(data)
      if(response){
        setAlertType('success')
      }else{
        setAlertType('error')
      }
      setSend(false)
      refDiv.current.scrollIntoView({behavior: 'smooth'})
      setTimeout(() => {
        setAlertType('')
        setPing(!ping)
        handleClose()
      }, 3000);
    })

  return (
    <section>
    <Alert
      tipo_alert={msj || alertType}
      type={msj || alertType}
    />
    <div className="row">
        <div ref={refDiv}/>
        <div className="col-12">
            <div className="card">
                <div className="card-body">
                    <form onSubmit={onSubmit}>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="nombre" className="form-label">Nombre *</label>
                                    <input type="text" className="form-control" id="nombre" 
                                    {...register('nombre', {
                                        required: true,
                                        minLength: 5,
                                        maxLength: 160
                                    })} />
                                    <Alert
                                        tipo_alert="danger"
                                        type={errors.nombre?.type}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="ruc" className="form-label">Ruc *</label>
                                    <input type="text" className="form-control" id="ruc" 
                                        {...register('ruc', {
                                            required: true,
                                            minLength: 10,
                                            maxLength: 13
                                        })} />
                                    <Alert
                                        tipo_alert="danger"
                                        type={errors.ruc?.type}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="razon_social" className="form-label">Razon Social *</label>
                                    <input type="text" className="form-control" id="razon_social" 
                                    {...register('razon_social', {
                                        required: true,
                                        minLength: 5,
                                        maxLength: 160
                                    })} />
                                    <Alert
                                        tipo_alert="danger"
                                        type={errors.razon_social?.type}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="direccion" className="form-label">Direccion *</label>
                                    <input type="text" className="form-control" id="direccion"
                                    {...register('direccion', 
                                        {
                                            required: true,
                                            minLength: 5,
                                            maxLength: 160
                                        })} />
                                    <Alert
                                        tipo_alert="danger"
                                        type={errors.direccion?.type}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="responsable" className="form-label">Responsable *</label>
                                    <input type="text" className="form-control" id="responsable" 
                                    {...register('responsable', 
                                    {
                                        required: true,
                                        minLength: 5,
                                        maxLength: 160
                                    })} />
                                    <Alert
                                        tipo_alert="danger"
                                        type={errors.responsable?.type}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="telefono" className="form-label">Telefono *</label>
                                    <input type="text" className="form-control" id="telefono" 
                                    {...register('telefono', {required: true})} />
                                    <Alert
                                        tipo_alert="danger"
                                        type={errors.telefono?.type}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="correo_electronico" className="form-label">Correo Electronico *</label>
                                    <input type="text" className="form-control" id="correo_electronico" {...register('correo_electronico', {required: true})} />
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="medico_auditor" className="form-label">Medico Auditor *</label>
                                    <SelectSearchble
                                        listCompany={doctores} 
                                        handleChange={handleChange} 
                                        selectedOption={selectedOption} 
                                        placeholder="Seleccione un medico"
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="tipo_seguro" className="form-label">Tipo de Seguro *</label>
                                    <SelectSearchble
                                        listCompany={tipoSeguro} 
                                        handleChange={handleChangeTipoSeguro} 
                                        selectedOption={selectedTSeguroOption} 
                                        placeholder="Seleccione un tipo de seguro"
                                    />
                                </div>
                            </div>

                            <div className="form-check form-switch flex col-md-6">
                                <div className="form-check form-switch">
                                    <label htmlFor="fecha_corte" className="form-label">Fecha Corte</label>
                                    <input type="checkbox" className="form-check-input" id="fecha_corte"
                                        name='fecha_corte'
                                        checked={fecha_corte}
                                        onChange={(e)=>{
                                            setFechaCorte(e.target.checked)
                                        }}
                                    />
                                </div>
                                <div className="w-50">
                                    {
                                        fecha_corte ?
                                        <input type="date" 
                                        className="form-control" id="fecha_corte_seguro" 
                                            value={fecha_corte_seguro}
                                            name='fecha_corte_seguro'
                                            onChange={(e)=>{
                                                setFechaCorteSeguro(e.target.value)
                                            }}
                                        />
                                        : null
                                    }
                                </div>
                                <div className="form-check form-switch">
                                    <input type="checkbox" className="form-check-input" id="estado" 
                                    {...register('estado', {
                                        required: false,
                                        defaultChecked: false
                                    })} />
                                    <label htmlFor="estado" className="form-label">Estado</label>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <button 
                                type="button"
                                onClick={()=>handleClose()}
                                className="btn btn-danger m-1">
                                Cancelar
                            </button>
                            <button type="submit" className="btn btn-primary">
                                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2 btnSppinAjax" 
                                style={{
                                    display: send ? 'inline-block' : 'none' 
                                }}></i>
                                {editSeguro ? 'Actualizar' : 'Crear'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    </section>
  )
}
